import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAuthUser from './hooks/useAuthUser';
import { capturePageview, isExcludedFromCapture } from '../posthog';

/**
 * Mounted inside AuthProvider (like HotjarProvider) so an authenticated user's first
 * pageview cannot fire before their role is known. Moving it higher would leak staff
 * pageviews.
 */
function PostHogPageviewTracker() {
  const authUser = useAuthUser();
  const { pathname, search } = useLocation();
  const isExcluded = isExcludedFromCapture(authUser);

  useEffect(() => {
    if (isExcluded) return;
    capturePageview();
  }, [pathname, search, isExcluded]);

  return null;
}

export default PostHogPageviewTracker;
